import type { FileUploadState } from "./useFileUpload";

export const isUploadBatchAllReady = (uploads: FileUploadState[]): boolean =>
  uploads.length > 0 && uploads.every((u) => u.status === "completed");
